import requestAxios from "@/helpers/request_axios";
import * as MutationsType from "./mutationsType";

export default {
  async getAllWarehouses({ commit }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/ecommerce/warehouses",
        method: "GET",
      });

      commit(MutationsType.SET_WAREHOUSES, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async getAllWarehousesByStore({ commit }, { storeId }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/ecommerce/warehouses",
        method: "GET",
        params: {
          store_id: storeId,
        },
      });

      commit(MutationsType.SET_WAREHOUSES, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async saveWarehouse({ commit }, { data }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/ecommerce/warehouses",
        method: "POST",
        data: data,
      });
      commit(MutationsType.ADD_WAREHOUSE, response.data.data);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async updateWarehouse({ commit }, { id, data }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/ecommerce/warehouses/${id}`,
        method: "PATCH",
        data: data,
      });
      commit(MutationsType.UPDATE_WAREHOUSE, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async deleteWarehouse({ commit }, { id }) {
    try {
      await requestAxios({
        url: `/awy/api/v1/ecommerce/warehouses/${id}`,
        method: "DELETE",
      });
      commit(MutationsType.DELETE_WAREHOUSE, { id });
    } catch (error) {
      throw error.response.data;
    }
  },
  async getAllWarehousesStockLogs({ commit }, { startAt, endAt }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/ecommerce/warehouses/logs?start_at=${startAt}&end_at=${endAt}`,
        method: "GET",
      });
      commit(MutationsType.SET_WAREHOUSES_STOCK_LOGS, response.data.data);
    } catch (error) {
      console.error(error);
      throw error.response.data;
    }
  },
  // eslint-disable-next-line
  async saveWarehouseStockPurchase({}, { data }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/ecommerce/warehouses/stock/purchase",
        method: "POST",
        data: data,
      });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  // eslint-disable-next-line
  async saveWarehouseStockTransfer({}, { data }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/ecommerce/warehouses/stock/transfer",
        method: "POST",
        data: data,
      });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  // eslint-disable-next-line
  async saveWarehouseStockMerma({}, { data }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/ecommerce/warehouses/stock/merma",
        method: "POST",
        data: data,
      });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  resetWarehouses({ commit }) {
    commit(MutationsType.SET_WAREHOUSES, null);
  },
  // eslint-disable-next-line
  async downloadLogs({}, { startAt, endAt }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/ecommerce/warehouses/logs/download?start_at=${startAt}&end_at=${endAt}`,
        method: "GET",
        responseType: "blob",
      });
      return response.data;
    } catch (error) {
      console.error("downloadLogs: ", error);
      throw error.response.data;
    }
  },
};
